// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"1877": "4710e733","2549": "3a9323d3","2897": "3a9323d3","2963": "3a9323d3","2991": "3a9323d3","5955": "bfd26030","842": "3a9323d3",}[chunkId] + ".css"
}